const $inject = [
  "$scope",
  "$state",
  "$cookies",
  "$timeout",
  "$sce",
  "AuthenticateService",
  "$uibModal",
];

class LoginController {
  /**
   * @constructor
   * @param $scope
   * @param $state
   * @param $cookies
   * @param $timeout
   * @param $sce
   * @param AuthenticateService
   * @param $uibModal
   */
  constructor(
    $scope,
    $state,
    $cookies,
    $timeout,
    $sce,
    AuthenticateService,
    $uibModal
  ) {
    this.$scope = $scope;
    this.$state = $state;
    this.sce = $sce;
    this.authenticateService = AuthenticateService;

    this.uibModal = $uibModal;
    this.submitted = false;

    this.globalData = window.globalData? window.globalData: {};

    this.username = null;
    this.password = null;
    this.pin = null;
    this.account = null;

    //Check for user details in the global data
    if (this.globalData.account) {
      this.account = this.globalData.account;
    }

    // Has the user already been through the entire authentication process ?
    if (this.$state.current.name === "app.login" && this.globalData.hasCookie) {
      // If so, send them to the password only login form
      this.$state.go("app.password");
    }

    // Is this a password reset request ?
    if (this.$state.current.name === "app.login" && this.globalData.hash) {
      // If so, open the password reset modal
      var self = this;
      $timeout(function () {
        self.openAccountModal("resetPsw");
      });
    }

    $scope.twoFactorMethods = {SMS: "SMS", EMAIL: "email"};

    $scope.twoFactorMethod = $cookies.get("2FA");
    if (!$scope.twoFactorMethod) {
      $scope.twoFactorMethod = "SMS";
    }

    $scope.$watch("twoFactorMethod", /**
     * @param {String} newVal
     * @param {String} oldVal
     */
    function (newVal, oldVal) {
      if (newVal !== oldVal) {
        $cookies.put("2FA", newVal);
      }
    });

    // Success login URL : referer (only if dashboard or direct HMR) or default URL
    if (this.globalData.referer && this.globalData.referer.indexOf("/app/dashboard") > -1) {
      this.successLoginUrl = this.globalData.referer;
    }
    else {
      this.successLoginUrl = "/app/";
    }

    this.submittedAuthenticate = {
      error: false,
      message: null,
    };
    this.submittedCheckPin = {
      error: false,
      message: null,
    };
  }

  authenticate(form) {
    // Scope
    var self = this;
    this.submitted = true;

    /**
     * Callback on success
     * @param response
     */
    var handleSuccess = function (response) {
      self.loading = false;

      if (!response.data.error) {
        // If fully authenticated (returning user)
        if (response.data.data.authenticated) {
          window.location.href = self.successLoginUrl;
        }
        // If first-time user (or expired cookie)
        else {
          self.$state.go("app.pin");
        }
      }
      else {
        handleError(response);
      }
    };

    /**
     * Callback on error
     * @param data
     */
    var handleError = function (data) {
      self.loading = false;
      self.errorMessage = data.data.message;
    };

    if (form.$valid) {
      this.loading = true;
      this.authenticateService.authenticate({
        username: this.username,
        password: this.password,
        "2fa": this.$scope.twoFactorMethod,
      }, this.username, this.password, handleSuccess, handleError);
    }
  }

  /**
   * Verify the PIN code
   * @param {Object} form
   */
  checkPin(form) {
    // Scope
    var self = this;

    /**
     * Callback on success
     * @param response
     */
    var handleSuccess = function (response) {
      self.loading = false;
      if (!response.data.error && response.data.data.authenticated) {
        self.authenticateService.credentials = {
          username: null,
          password: null,
          "2fa": null,
        };
        window.location.href = self.successLoginUrl;
      }
      else {
        handleError(response);
      }
    };

    /**
     * Callback on error
     * @param data
     */
    var handleError = function (data) {
      self.loading = false;
      self.errorMessage = data.data.message;
    };

    if (form.$valid) {
      this.loading = true;
      this.authenticateService.pin(this.pin, handleSuccess, handleError);
    }
  }

  /**
   * Open Forgotten Password Modal
   */
  openAccountModal(type) {
    var title, msg;

    switch (type) {
      case "forgotPsw":
        title = "Forgotten Password";
        msg = "<p>If you cannot remember your password, not to worry.</p><p>Enter your email and MRN to reset your password.</p>";
        break;

      case "resetPsw":
        title = "Reset Password";
        msg = "<p>You have requested to reset your password. If you did not intend to do so, please cancel below or just close this page.</p>";
        break;
    }

    var self = this;

    var modalInstance = this.uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "accountModal.html",
      controller: "AccountModalController",
      controllerAs: "accountCtrl",
      resolve: {
        items: function () {
          return {
            title: title,
            msg: self.sce.trustAsHtml(msg),
            type: type,
          };
        },
      },
    });

    modalInstance.result.then(function (selectedItem) {
      //callback accept
    }, function () {
      //callback dismiss
    });
  }
}

LoginController.$inject = $inject;

export default LoginController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/account/controllers/login.controller.js
 **/